import moment from 'moment';
import { DateTime } from 'luxon';
import { DATE_FORMAT, TIMES_ZONE } from './constants/dateConstants';


export const formatSecondsToDate = (secs)=>{
    const isoDate = DateTime.fromMillis(secs*1000, {zone: TIMES_ZONE}).toFormat(DATE_FORMAT);
    return isoDate
}

export const getTimePeriodByDuration = (startMonthYear, endMonthYear) => {
  if (!startMonthYear && !endMonthYear) {
    return {};
  }
  const start = moment
    .utc(startMonthYear, ["MM-YYYY", "YYYY-MM"], true)
    .startOf("month"); // 00:00:00Z
  const end = moment
    .utc(endMonthYear, ["MM-YYYY", "YYYY-MM"], true)
    .endOf("month"); // 23:59:59Z

  if (!start.isValid() || !end.isValid()) {
    return {};
  }
  return {
    start: Math.floor(start.valueOf() / 1000),
    end: Math.floor(end.valueOf() / 1000),
  };
};

export function getUTCTimestamp() {
    return moment().utc().unix()
}

export const dateToUtcUnixSeconds=(date) =>{ // only date no time
  if (!date) return null
  return Math.floor(
    Date.UTC(
      date.getFullYear(),
      date.getMonth(),
      date.getDate()
    ) / 1000
  );
}

// export const utcUnixSecondsToDate=(utcSeconds) =>{ //only date utcsecond not time
//   console.log("utcSeconds",utcSeconds);  // output utcSeconds "2026-04-21"
  
//   if(!utcSeconds) return null
//   return new Date(utcSeconds * 1000);
// }

export const utcUnixSecondsToDate = (value) => {
  // console.log("value",value); // output value 1777593600
  
  if (!value) return null;

  // Case 1: Unix seconds (number or numeric string)
  if (!Number.isNaN(Number(value))) {
    const seconds = Number(value);
    const date = new Date(seconds * 1000);
    return Number.isNaN(date.getTime()) ? null : date;
  }

  // Case 2: ISO date string (YYYY-MM-DD)
  if (typeof value === "string") {
    const date = new Date(`${value}T00:00:00Z`);
    return Number.isNaN(date.getTime()) ? null : date;
  }

  return null;
};